<template>
  <div class="CompanyAdminView">
    <RouterView />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import * as UserAccount from '@/store/modules/App/UserAccount/UserAccountModule';

export default {
  name: 'CompanyAdminView',
  components: {
  },
  computed: {
    ...mapState(UserAccount.FULL_NAMESPACE, {
      userAccountState: state => state.data,
    }),
  },
};
</script>
